export function useIsMounted() {
  const isMounted = ref(false);
  const isHydrated = ref(false);

  onMounted(() => {
    isMounted.value = true;

    nextTick(() => {
      isHydrated.value = true;
    });
  });

  return {
    isMounted: readonly(isMounted),
    isHydrated: readonly(isHydrated),
  };
}
